<template>
  <v-container fluid grid-list-md>
    <v-row v-if="!somenteLeitura">
      <v-col cols="12" sm="1">
        <input-number
          id="qtdLinhas_input"
          prepend-icon=""
          label=""
          v-model="valorQtdLinhasAdicionar"/>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-btn id="add_linhas" @click="adicionarLinhas()" style="margin-top: 0.8em;">
          {{ $tc('label.adicionar_linha', 2) }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <div class="title">{{ $tc('label.linha_investimento', 2) }}</div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon
            id="rateio-botao-exportar"
            v-on="on"
            @click="exportarSpreadsheet">
            <v-icon>get_app</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('label.exportar_conteudo') }}</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <spreadsheet
        ref="spreadsheet"
        selectRange="A2"
        v-if="planilhaPronta"
        :toolbar="false"
        :tamanhoColunas="tamanhoColunas"
        :sheetsbar="false"
        :rows="qtdeLinhas"
        :data="datasource"
        :colunas="colunas"
        :estilos="estilos"
        :frozenRows="1"
        :autocomplete="true"/>
    </v-row>
  </v-container>
</template>
<script>
import Spreadsheet from '../../produto/shared-components/spreadsheet/Spreadsheet';
import { toColumnName } from '../../produto/common/functions/helpers';
import InputNumber from '../../produto/shared-components/inputs/InputNumber';

export default {
  components: {
    Spreadsheet,
    InputNumber,
  },
  props: {
    edicao: Boolean,
    somenteLeitura: Boolean,
    ajusteVerba: {
      type: Object,
      required: true,
    },
  },
  computed: {
    linhasInvestimento() {
      return this.ajusteVerba.linhas;
    },
  },
  data() {
    return {
      ajusteVerbaResource: this.$api.ajusteVerbaMassivo(this.$resource),
      extensaoResource: this.$api.extensao(this.$resource),

      planilhaPronta: false,

      datasource: [],
      colunas: [],
      tamanhoColunas: [],
      estilos: [],
      formulas: [],
      qtdeLinhas: 50,
      valorQtdLinhasAdicionar: 0,

      colunasBase: [
        {
          field: 'descricao',
          title: `${this.$tc('label.linha', 1)}`,
        },
        {
          field: 'tipoInvestimento',
          title: `${this.$tc('label.tipo_de_investimento', 1)}`,
          datasource: (autocomplete) => {
            const params = {
              idTipoVerba: this.ajusteVerba.tipoVerba.id,
            };
            if (autocomplete) {
              params.filtro = autocomplete;
            }
            return this.ajusteVerbaResource.buscarTiposLinha(params);
          },
          atributo: 'nome',
        },
        {
          field: 'grupoEconomico',
          title: `${this.$tc('label.grupoeconomico', 1)}`,
          datasource: (autocomplete) => {
            const params = { autocomplete, mnemonico: 'HOLDING' };
            return this.extensaoResource.selecaoMnemonico(params);
          },
          atributo: 'codNomExtensao',
        },
      ],

      estiloTitulo: {
        textAlign: 'center',
        bold: true,
        enable: false,
        background: this.$vuetify.theme.currentTheme.primary,
        color: 'rgb(255,255,255)',
      },
      estiloSomenteLeituraTexto: { enable: false, color: 'rgb(0,0,0)' },
      estiloSomenteLeituraNro: { enable: false, background: 'rgb(191,191,191)', color: 'rgb(0,0,0)' },
    };
  },
  methods: {
    refazerSpreadsheet() {
      this.planilhaPronta = false;
      setTimeout(() => this.iniciaPlanilha());
    },
    exportarSpreadsheet() {
      this.$refs.spreadsheet.exportarExcel();
    },
    getCelulaEntidade(entidade) {
      switch (entidade) {
        case 'descricao':
          return 'A';
        case 'tipo_investimento':
          return 'B';
        case 'grupoeconomico':
          return 'C';
        case 'chave':
          return 'B';
        default:
          return 'D';
      }
    },
    iniciaPlanilha() {
      this.montarColunas();
      this.preencheDados();
      this.aplicaEstiloColunas();
      this.planilhaPronta = true;
    },
    preencheDados() {
      this.datasource = [...this.linhasInvestimento];
      this.qtdeLinhas = this.linhasInvestimento && this.linhasInvestimento.length > 50
        ? this.linhasInvestimento.length + 15 : 50;
    },
    colunaPeriodo() {
      return {
        field: 'valorPeriodo',
        title: `${this.$tc('label.valor_aporte_para', 1)} ${this.ajusteVerba.periodoOrcamentario.descricao}`,
      };
    },
    colunasCC() {
      return [
        {
          field: 'planejado',
          title: this.$tc('label.valor_planejado'),
        },
        {
          field: 'saldo',
          title: this.$tc('label.saldo'),
        },
      ];
    },
    montarColunas() {
      this.colunas = [
        ...this.colunasBase,
        this.colunaPeriodo(),
        ...this.colunasCC(),
      ];
    },
    aplicaEstiloColunas() {
      this.estilos = [];
      this.formulas = [];
      this.aplicaTamanhoColunas();
      this.aplicaEstiloCabecalho();
      this.aplicaEstiloDesabilitados();
      this.aplicaEstiloCampoNumerico();
      // this.aplicaEstiloUltimaLinha();
    },
    aplicaTamanhoColunas() {
      this.tamanhoColunas = [
        { width: 300 },
        { width: 200 },
        { width: 250 },
        { width: 250 },
        { width: 200 },
        { width: 200 },
      ];
    },
    aplicaEstiloCabecalho() {
      const letraInicial = toColumnName(0);
      const letraFinal = toColumnName(this.colunas.length - 1);
      this.estilos.push({ range: `${letraInicial}1:${letraFinal}1`, metodos: this.estiloTitulo });
    },
    aplicaEstiloDesabilitados() {
      if (!this.somenteLeitura) {
        this.estilos.push(
          {
            range: `A2:C${this.datasource.length + 1}`,
            metodos: this.estiloSomenteLeituraTexto,
          },
          {
            range: `E2:F${this.qtdeLinhas}`,
            metodos: this.estiloSomenteLeituraNro,
          },
        );
      } else {
        this.estilos.push(
          {
            range: `A2:D${this.qtdeLinhas}`,
            metodos: this.estiloSomenteLeituraTexto,
          },
          {
            range: `E2:F${this.qtdeLinhas}`,
            metodos: this.estiloSomenteLeituraNro,
          },
        );
      }
    },
    aplicaEstiloUltimaLinha() {
      const letraInicial = toColumnName(0),
        letraFinal = toColumnName(this.colunas.length - 1),
        numeroLinha = this.qtdeLinhas;

      this.estilos.push({
        range: `${letraInicial}${numeroLinha}:${letraFinal}${numeroLinha}`,
        metodos: this.estiloSomenteLeituraTexto,
      });
    },
    aplicaEstiloCampoNumerico() {
      const max = 9999999999.99,
        min = 0.00;

      this.estilos.push({
        range: `D2:F${this.qtdeLinhas}`,
        metodos: { format: '[>=0][BLACK]###,##0.00;[RED]###,##0.00' },
      });
      this.formulas.push({
        range: `D2:F${this.qtdeLinhas}`,
        metodos: {
          validation: {
            allowNulls: true,
            comparerType: 'between',
            from: min,
            to: max,
            dataType: 'number',
            type: 'reject',
            messageTemplate:
              this.$t('message.intervalo_numerico', { min, max }),
            titleTemplate: this.$tc('title.erro', 1),
          },
        },
      });
    },
    valida() {
      const valido = this.linhasValidas()
        .map((r) => r.valorPeriodo || 0)
        .reduce((a, b) => a + b, 0) > 0;

      if (!valido) {
        this.$toast(this.$t('erros.ajuste_verba.valor_maior_que_zero'));
      }

      return valido;
    },
    linhasValidas() {
      const dataSource = this.$refs.spreadsheet.getDataSource();

      for (let i = 0; i < dataSource.length; i += 1) {
        const row = dataSource[i];
        if (row && !row.idLinhaInvestimento && row.descricao
        && (this.datasource[i] && row.descricao.replaceAll('\u00A0', '').trim() === this.datasource[i].descricao.replaceAll('\u00A0', '').trim())) {
          row.idLinhaInvestimento = this.datasource[i].idLinhaInvestimento;
        }
      }

      // Filtra as linhas que possuem algo preenchido
      return dataSource
        .map((r) => JSON.parse(JSON.stringify(r)))
        .filter((r) => Object.keys(r).filter((k) => !!r[k]).length > 0);
    },
    adicionarLinhas() {
      this.qtdeLinhas += this.valorQtdLinhasAdicionar;
      if (this.qtdeLinhas > 1500) {
        this.qtdeLinhas = 1500;
      }
      this.valorQtdLinhasAdicionar = 0;
      setTimeout(() => this.$refs.spreadsheet.recriar());
      this.aplicaEstiloColunas();
    },
  },
  mounted() {
    this.iniciaPlanilha();
  },
};
</script>
